// export const BASE_URL="http://localhost:5000"


export const BASE_URL="https://elex-backend-aaa9axb8ghhvfmfp.westeurope-01.azurewebsites.net"